import { FC, memo } from 'react'
import { useField, UseFieldConfig } from 'react-final-form'
import { Input, InputProps, useIMask } from '@cargomart/ui'
import { formatMobilePhone, parseMobilePhone } from 'helpers/formatPhone'
import { checkFieldError } from 'src/shared/helpers/form'

interface FieldMobilePhoneProps
  extends Omit<
    InputProps,
    'onChange' | 'onFocus' | 'onBlur' | 'inputComponent' | 'inputProps' | 'type' | 'error' | 'value'
  > {
  name: string
  maskType?: 'cell' | 'city'
  testId?: string
  validate?: UseFieldConfig<string>['validate']
}

const prepare = (value: string, masked: any) => {
  if (value.length > 10 && value.startsWith('8')) {
    return value.replace('8', '7')
  }

  if ((!masked.value || masked.value === '+') && value === '8') {
    return '7'
  }

  return value
}

const MASKS_BY_TYPE = {
  city: '+7 000 000 00-00',
  cell: '+7 900 000 00-00'
}
const FieldMobilePhone: FC<FieldMobilePhoneProps> = (props) => {
  const {
    name,
    validate,
    size = 'nm',
    placeholder = '+7 999 999 99-99',
    maskType = 'cell',
    testId,
    ...otherProps
  } = props
  const { input, meta } = useField<string>(name, {
    validate,
    parse: parseMobilePhone,
    format: (value: string) => formatMobilePhone(value)
  })
  const { value, onBlur, onFocus, onChange } = input
  const { ref } = useIMask({ mask: MASKS_BY_TYPE[maskType], prepare }, { onAccept: onChange }, { value })

  return (
    <Input
      {...otherProps}
      data-test-id={testId}
      inputRef={ref}
      invalid={!!checkFieldError(meta)}
      name={name}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      size={size}
      type="text"
    />
  )
}

export default memo(FieldMobilePhone)
